import { BaseField } from './BaseField';

const imgExposureIcon = "/assets/exposure-icon.svg";

export class ExposureField extends BaseField {
  constructor() {
    super({
      key: 'exposure',
      icon: imgExposureIcon,
      defaultLabel: 'Ekspozycja'
    });
  }

  renderForList(property) {
    const exposure = property.exposure;

    if (exposure) {
      return { label: 'Ekspozycja', value: exposure };
    }
    return null;
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}